import styled from 'styled-components';

export const Container = styled.div`
    grid-area: MH;

    background-color: '#252a48';

    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 10px;

    border-bottom:  1px solid gray;
`;

export const Profile = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const Welcome = styled.h3``;

export const LogImg = styled.img`
    width: 200px;
`;
